import { useIntl } from '@capsicum/common';

export const useDottedMenu = () => {
	const { $t } = useIntl();

	const transactionHistory = $t('wallet.transactionHistory.goToTransactionHistory');
	const redeemVoucher = $t('wallet.voucher.redeemVoucher');

	return {
		intlText: {
			redeemVoucher,
			transactionHistory
		}
	};
};
